import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDz = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { fill: "#fff", width: 900, height: 600 }), /* @__PURE__ */ React.createElement("rect", { fill: "#006233", width: 450, height: 600 }), /* @__PURE__ */ React.createElement("path", { fill: "#d21034", d: "M580,225a150,150 0 1,0 0,150 120,120 0 1,1 0-150m5,75-135-44 84,115v-142l-84,115z" }));
const ForwardRef = forwardRef(SvgDz);
const Memo = memo(ForwardRef);
export default Memo;
